/*  SHARED WysiwygEditor TOOLBAR CONFIGS
    Pass to <WysiwygEditor :toolbar="..."> so every notes editor looks and behaves the same.
*/

// Quick notes / manual notes (Projects, ProjectData, BuyerComparison, BuyerDetails, ActivityLogs)
export const quickNotesToolbar = [
    [
        { fontSize: "normal" },
        { textColor: true },
        { highlight: true }
    ],
    [
        "bold",
        "italic",
        "underline",
        "strikethrough"
    ],
    [
        { align: "" },
        { align: "center" },
        { align: "right" }
    ],
    [
        { list: "ordered" },
        { list: "bullet" }
    ],
    [
        { clearFormatting: true }
    ]
]



// WEBPACK FOOTER //
// ./src/components/shared/editorToolbars.js